import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { peopleService } from '../../../services/peopleService'
import { useSelectedPropertyId } from '../../../store/propertyStore'
import { useAuthStore } from '../../auth/store/authStore'
import { ELIGIBLE_MANAGERS_QUERY_KEY } from '../constants/handoverConstants'
import type { User } from '../../../types/api.types'

export function useEligibleManagers(): UseQueryResult<User[]> {
  const propertyId = useSelectedPropertyId()
  const currentUserId = useAuthStore((s) => s.user?.id ?? null)
  return useQuery<User[]>({
    queryKey: [ELIGIBLE_MANAGERS_QUERY_KEY, { propertyId, currentUserId }],
    queryFn: async () => {
      const all = await peopleService.getAll()
      return all.filter(
        (u) => u.role === 'MANAGER' && u.id !== currentUserId && (propertyId === null || u.property_ids.includes(propertyId)),
      )
    },
    enabled: propertyId !== null,
    meta: { silent: true, source: 'useEligibleManagers' },
  })
}
